export default {
  voteSummary: {
    for: 'proposal-vote-summary-for',
    against: 'proposal-vote-summary-against',
    abstain: 'proposal-vote-summary-abstain',
  },
};
